import React, { useState, useEffect } from "react";
import { IoMdBackspace } from "react-icons/io";
import {
    MdLocationOn,
    MdPhone,
    MdEmail,
    MdPerson,
    MdStorefront,
    MdLocalShipping,
    MdInventory2,
} from "react-icons/md";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Modal } from "antd";
import { config } from "../../utils/config";
const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.nKy8wA7U6iYNqhz-8qwPXUN47YjLxS8OCgU8A_-8qXQ"
/* ─── helpers ─────────────────────────────────────── */
const safeParse = (str) => {
    try {
        return typeof str === "string" ? JSON.parse(str) : str;
    } catch {
        return null;
    }
};

const formatAddress = (addr) => {
    if (!addr) return "—";
    const parts = [
        addr.door,
        addr.building,
        addr.name,
        addr.street,
        addr.locality,
        addr.city,
        addr.state,
        addr.area_code,
    ].filter(Boolean);
    return parts.join(", ");
};

const formatCurrency = (val) => {
    const num = Number(val);
    if (isNaN(num)) return val;
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(num / 100);
};

/* ─── sub-components ──────────────────────────────── */
const InfoRow = ({ label, value, icon: Icon }) => (
    <div style={styles.infoRow}>
        {Icon && (
            <span style={styles.infoIcon}>
                <Icon size={14} />
            </span>
        )}
        <span style={styles.infoLabel}>{label}</span>
        <span style={styles.infoValue}>{value || "—"}</span>
    </div>
);

const SectionCard = ({ title, icon: Icon, color = "#37C790", children }) => (
    <div style={styles.sectionCard}>
        <div style={{ ...styles.sectionHeader, borderLeftColor: color }}>
            {Icon && (
                <span style={{ ...styles.sectionIcon, background: color + "20", color }}>
                    <Icon size={16} />
                </span>
            )}
            <span style={styles.sectionTitle}>{title}</span>
        </div>
        <div style={styles.sectionBody}>{children}</div>
    </div>
);

/* Collapsible accordion card */
const CollapsibleCard = ({ title, icon: Icon, color = "#37C790", summary, children, isOpen, onToggle }) => (
    <div style={styles.sectionCard}>
        {/* Header row – always visible */}
        <div
            style={{ ...styles.sectionHeader, borderLeftColor: color, cursor: "pointer", userSelect: "none" }}
            onClick={onToggle}
        >
            {Icon && (
                <span style={{ ...styles.sectionIcon, background: color + "20", color }}>
                    <Icon size={16} />
                </span>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
                <span style={styles.sectionTitle}>{title}</span>
                {!isOpen && summary && (
                    <div style={styles.summaryText}>{summary}</div>
                )}
            </div>
            <span
                style={{
                    ...styles.chevron,
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    color,
                }}
            >
                ▾
            </span>
        </div>
        {/* Expandable body */}
        {isOpen && <div style={styles.sectionBody}>{children}</div>}
    </div>
);

/* ─── main component ──────────────────────────────── */
const VerifyOTP = () => {
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [status, setStatus] = useState("default");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("order_id");
    const [loading, setLoading] = useState(false);
    const [orderLoading, setOrderLoading] = useState(true);
    const [orderData, setOrderData] = useState(null);
    const [products, setProducts] = useState([]);

    /* collapsible section open/close state */
    const [openSection, setOpenSection] = useState(null); // "customer" | "delivery" | "pickup"
    const toggleSection = (key) => setOpenSection((prev) => (prev === key ? null : key));

    /* status update loading: null | "picked" | "out" */
    const [updateStatusLoading, setUpdateStatusLoading] = useState(null);

    /* Delivery OTP modal */
    const [otpModalOpen, setOtpModalOpen] = useState(false);

    /* Pickup OTP modal */
    const [pickupOtpModalOpen, setPickupOtpModalOpen] = useState(false);
    const [pickupOtp, setPickupOtp] = useState(["", "", "", ""]);
    const [pickupStatus, setPickupStatus] = useState("default");
    const [pickupLoading, setPickupLoading] = useState(false);

    /* ── derived parsed values ── */
    const billing = orderData ? safeParse(orderData.billing) : null;
    const fulfillments = orderData ? safeParse(orderData.fulfillments) : null;
    const fulfillment = fulfillments?.[0] ?? null;
    const customerAddress = fulfillment?.end?.location?.address ?? billing?.address ?? null;
    const pickupAddress = fulfillment?.start?.location?.address ?? null;
    const pickupContact = fulfillment?.start?.contact ?? null;
    const pickupSeller = fulfillment?.start?.location?.descriptor ?? null;

    /* ── fetch order on mount ── */
    useEffect(() => {
        if (!orderId) return;
        const fetchOrder = async () => {
            try {
                setOrderLoading(true);
                const token = sessionStorage.getItem("us_st_d");
                const response = await axios.post(
                    `${config.apiEndpoint}/getsellerorder`,
                    { order_id: orderId },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                            "x-custom-authorization": `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.nKy8wA7U6iYNqhz-8qwPXUN47YjLxS8OCgU8A_-8qXQ`,
                        },
                    }
                );
                if (response?.data?.data?.length) {
                    setOrderData(response.data.data[0]);
                    setProducts(response.data.products || []);
                }
            } catch (err) {
                console.error("Failed to fetch order:", err);
                toast.error("Could not load order details", { position: "top-center" });
            } finally {
                setOrderLoading(false);
            }
        };
        fetchOrder();
    }, [orderId]);

    /* ── delivery OTP keypad handlers ── */
    const handleNumberClick = (num) => {
        if (status === "success") return;
        const emptyIndex = otp.findIndex((d) => d === "");
        if (emptyIndex !== -1) {
            const newOtp = [...otp];
            newOtp[emptyIndex] = num;
            setOtp(newOtp);
            setStatus("default");
        }
    };

    const handleDelete = () => {
        if (status === "success") return;
        const lastFilled = [...otp].reverse().findIndex((d) => d !== "");
        if (lastFilled !== -1) {
            const actualIndex = otp.length - 1 - lastFilled;
            const newOtp = [...otp];
            newOtp[actualIndex] = "";
            setOtp(newOtp);
            setStatus("default");
        }
    };

    /* ── pickup OTP keypad handlers ── */
    const handlePickupNumberClick = (num) => {
        if (pickupStatus === "success") return;
        const emptyIndex = pickupOtp.findIndex((d) => d === "");
        if (emptyIndex !== -1) {
            const newOtp = [...pickupOtp];
            newOtp[emptyIndex] = num;
            setPickupOtp(newOtp);
            setPickupStatus("default");
        }
    };

    const handlePickupDelete = () => {
        if (pickupStatus === "success") return;
        const lastFilled = [...pickupOtp].reverse().findIndex((d) => d !== "");
        if (lastFilled !== -1) {
            const actualIndex = pickupOtp.length - 1 - lastFilled;
            const newOtp = [...pickupOtp];
            newOtp[actualIndex] = "";
            setPickupOtp(newOtp);
            setPickupStatus("default");
        }
    };

    /* ── update order fulfillment state ── */
    const updateOrderStatus = async (fulfillmentState, key) => {
        try {
            setUpdateStatusLoading(key);
            // const token = sessionStorage.getItem("us_st_d");
            const response = await axios.post(
                `${config.apiEndpoint}/updateorderstatus`,
                {
                    order_id: orderId,
                    order_state: "In-progress",
                    fulfillment_state: fulfillmentState,
                    tracking_url: null,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "x-custom-authorization": `Bearer ${token}`,
                    },
                }
            );
            if (response?.data?.message === "flag1" || response?.status === 200) {
                toast.success(
                    fulfillmentState === "Order-picked-up"
                        ? "Order marked as Picked Up!"
                        : "Order marked as Out for Delivery!",
                    { position: "top-center", autoClose: 3000 }
                );
            } else {
                toast.error("Update failed. Please try again.", { position: "top-center" });
            }
        } catch (err) {
            console.error("Status update error:", err);
            toast.error(
                err?.response?.data?.message || "Something went wrong",
                { position: "top-center" }
            );
        } finally {
            setUpdateStatusLoading(null);
        }
    };

    /* ── verify delivery OTP ── */
    const verifyOtp = async () => {
        try {
            setLoading(true);
            const enteredOtp = otp.join("");
            const apiUrl = config.baseNodeapiUrl;
            const response = await axios.post(
                `${apiUrl}/admin/api/verify-delivery-otp`,
                { order_id: orderId, otp: enteredOtp },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response?.data?.data) {
                setStatus("success");
                toast.success(response.data.message || "Delivery confirmed!", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });
            } else {
                setStatus("error");
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message || "Something went wrong",
                { position: "top-center", autoClose: 5000, theme: "light" }
            );
            setStatus("error");
        } finally {
            setLoading(false);
        }
    };

    /* ── verify pickup OTP ── */
    const verifyPickupOtp = async () => {
        try {
            setPickupLoading(true);
            const enteredOtp = pickupOtp.join("");
            const apiUrl = config.baseNodeapiUrl;
            const response = await axios.post(
                `${apiUrl}/admin/api/verify-pickup-otp`,
                { order_id: orderId, otp: enteredOtp },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response?.data?.data || response?.status === 200) {
                setPickupStatus("success");
                toast.success(response?.data?.message || "Pickup verified!", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });
                setPickupOtpModalOpen(false);
                setPickupOtp(["", "", "", "", "", ""]);
                setPickupStatus("default");
            } else {
                setPickupStatus("error");
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message || "Something went wrong",
                { position: "top-center", autoClose: 5000, theme: "light" }
            );
            setPickupStatus("error");
        } finally {
            setPickupLoading(false);
        }
    };

    const activeIndex = otp.findIndex((d) => d === "");
    const pickupActiveIndex = pickupOtp.findIndex((d) => d === "");

    /* ── loading skeleton ── */
    if (orderLoading) {
        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <div style={styles.skeletonHeader} />
                    {[1, 2, 3].map((i) => (
                        <div key={i} style={{ ...styles.skeleton, width: i % 2 === 0 ? "60%" : "80%", marginBottom: 12 }} />
                    ))}
                    <div style={{ ...styles.skeleton, height: 100, marginTop: 8 }} />
                </div>
            </div>
        );
    }

    /* ── success view ── */
    if (status === "success") {
        return (
            <div style={styles.page}>
                <ToastContainer />
                <div style={styles.card}>
                    <div style={styles.header}>
                        <span style={styles.headerEmoji}>🚴</span>
                        <strong style={styles.headerTitle}>Delivery Verification</strong>
                    </div>

                    <div style={{ textAlign: "center", padding: "32px 0 16px" }}>
                        <div style={styles.successRing}>
                            <div style={styles.successCheck}>✓</div>
                        </div>
                        <h2 style={styles.successTitle}>Delivery Confirmed!</h2>
                        <p style={styles.successSub}>
                            OTP matched. The order has been marked as delivered.
                        </p>
                    </div>

                    <SectionCard title="Order Summary" icon={MdInventory2} color="#37C790">
                        <InfoRow label="Order ID" value={"#" + orderId} />
                        <InfoRow label="Customer" value={billing?.name || orderData?.name} icon={MdPerson} />
                        <InfoRow label="Phone" value={orderData?.contact_number} icon={MdPhone} />
                        <InfoRow label="Status" value="✓ Delivered" />
                        {products[0] && (
                            <InfoRow label="Product" value={products[0].product_name} icon={MdStorefront} />
                        )}
                        {products[0] && (
                            <InfoRow label="Amount" value={formatCurrency(products[0].price)} />
                        )}
                    </SectionCard>
                    <div style={{ height: 24 }} />
                </div>
            </div>
        );
    }

    /* ── main OTP entry view ── */
    const product = products[0];

    return (
        <div style={styles.page}>
            <ToastContainer />
            <div style={styles.card}>

                {/* Header */}
                <div style={styles.header}>
                    <span style={styles.headerEmoji}>🚴</span>
                    <strong style={styles.headerTitle}>Delivery Verification</strong>
                    <span style={styles.orderBadge}>#{orderId}</span>
                </div>

                {/* Product Info */}
                {product && (
                    <div style={styles.productRow}>
                        <img
                            src={product.image}
                            alt={product.product_name}
                            style={styles.productImg}
                            onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={styles.productName}>{product.product_name}</div>
                            <div style={styles.productMeta}>
                                <span style={styles.productAmount}>{formatCurrency(product.price)}</span>
                                <span style={styles.productQty}>× {product.quantity}</span>
                            </div>
                        </div>
                    </div>
                )}
                {/* Pickup Details – collapsible */}
                <CollapsibleCard
                    title="Pickup Details"
                    icon={MdStorefront}
                    color="#10B981"
                    isOpen={openSection === "pickup"}
                    onToggle={() => toggleSection("pickup")}
                    summary={
                        [pickupSeller?.name, pickupContact?.phone].filter(Boolean).join(" · ")
                        || (pickupAddress ? formatAddress(pickupAddress).slice(0, 40) : "")
                    }
                >
                    {pickupSeller?.name && (
                        <InfoRow label="Seller" value={pickupSeller.name} icon={MdStorefront} />
                    )}
                    {pickupContact?.phone && (
                        <InfoRow label="Phone" value={pickupContact.phone} icon={MdPhone} />
                    )}
                    {pickupContact?.email && (
                        <InfoRow label="Email" value={pickupContact.email} icon={MdEmail} />
                    )}
                    {pickupAddress && (
                        <InfoRow
                            label="Address"
                            value={formatAddress(pickupAddress)}
                            icon={MdLocationOn}
                        />
                    )}
                    {/* Authenticate Pickup button */}
                    <button
                        style={styles.authPickupBtn}
                        onClick={(e) => { e.stopPropagation(); setPickupOtpModalOpen(true); }}
                    >
                        🔐 Authenticate with OTP
                    </button>
                </CollapsibleCard>

                {/* ── Quick Status Update Buttons ── */}
                <div style={styles.statusBtnRow}>
                    {/* <button
                        style={{
                            ...styles.statusBtn,
                            background: updateStatusLoading === "picked" ? "#059669" : "#10B981",
                            opacity: updateStatusLoading && updateStatusLoading !== "picked" ? 0.5 : 1,
                            cursor: updateStatusLoading ? "not-allowed" : "pointer",
                        }}
                        disabled={!!updateStatusLoading}
                        onClick={() => updateOrderStatus("Order-picked-up", "picked")}
                    >
                        {updateStatusLoading === "picked" ? "Updating…" : "📦 Order Picked"}
                    </button> */}

                    <button
                        style={{
                            ...styles.statusBtn,
                            background: updateStatusLoading === "out" ? "#2563EB" : "#3B82F6",
                            opacity: updateStatusLoading && updateStatusLoading !== "out" ? 0.5 : 1,
                            cursor: updateStatusLoading ? "not-allowed" : "pointer",
                        }}
                        disabled={!!updateStatusLoading}
                        onClick={() => updateOrderStatus("Out-for-delivery", "out")}
                    >
                        {updateStatusLoading === "out" ? "Updating…" : "🛵 Out for Delivery"}
                    </button>
                </div>

                {/* Customer Details – collapsible */}
                <CollapsibleCard
                    title="Customer Details"
                    icon={MdPerson}
                    color="#6366F1"
                    isOpen={openSection === "customer"}
                    onToggle={() => toggleSection("customer")}
                    summary={
                        [billing?.name || orderData?.name, orderData?.contact_number || billing?.phone]
                            .filter(Boolean).join(" · ")
                    }
                >
                    <InfoRow label="Name" value={billing?.name || orderData?.name} icon={MdPerson} />
                    <InfoRow label="Phone" value={orderData?.contact_number || billing?.phone} icon={MdPhone} />
                    {(orderData?.email || billing?.email) && (
                        <InfoRow label="Email" value={orderData?.email || billing?.email} icon={MdEmail} />
                    )}
                </CollapsibleCard>

                {/* Delivery Address – collapsible */}
                <CollapsibleCard
                    title="Delivery Address"
                    icon={MdLocationOn}
                    color="#F59E0B"
                    isOpen={openSection === "delivery"}
                    onToggle={() => toggleSection("delivery")}
                    summary={
                        customerAddress
                            ? [customerAddress.building, customerAddress.street, customerAddress.locality, customerAddress.city, customerAddress.area_code].filter(Boolean).join(", ")
                            : "No address available"
                    }
                >
                    {customerAddress ? (
                        <>
                            {customerAddress.building && (
                                <InfoRow label="Building" value={customerAddress.building} />
                            )}
                            {customerAddress.street && (
                                <InfoRow label="Street" value={customerAddress.street} />
                            )}
                            {customerAddress.locality && (
                                <InfoRow label="Locality" value={customerAddress.locality} />
                            )}
                            <InfoRow
                                label="City"
                                value={[customerAddress.city, customerAddress.state].filter(Boolean).join(", ")}
                            />
                            {customerAddress.area_code && (
                                <InfoRow label="Pin Code" value={customerAddress.area_code} />
                            )}
                        </>
                    ) : (
                        <p style={styles.noData}>No address information available</p>
                    )}
                    {/* Authenticate button */}
                    <button
                        style={styles.authOtpBtn}
                        onClick={(e) => { e.stopPropagation(); setOtpModalOpen(true); }}
                    >
                        🔐 Authenticate with OTP
                    </button>
                </CollapsibleCard>



                {/* Shipment Info */}
                {fulfillment && (
                    <SectionCard title="Shipment Info" icon={MdLocalShipping} color="#8B5CF6">
                        <InfoRow label="Type" value={fulfillment.type || "Delivery"} />
                        <InfoRow label="Order State" value={orderData?.order_state} />
                        <InfoRow label="Payment" value={orderData?.status} />
                        {orderData?.rider_phone && (
                            <InfoRow label="Rider Phone" value={orderData.rider_phone} icon={MdPhone} />
                        )}
                    </SectionCard>
                )}

                <div style={{ height: 24 }} />
            </div>

            {/* ─── Delivery OTP Modal (antd, centered + scrollable) ─── */}
            <Modal
                open={otpModalOpen}
                onCancel={() => { setOtpModalOpen(false); setOtp(["", "", "", ""]); setStatus("default"); }}
                footer={null}
                closable={false}
                maskClosable={true}
                centered
                width={440}
                styles={{
                    body: {
                        padding: 0,
                        maxHeight: "85vh",
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                    },
                    content: { padding: 0, borderRadius: "20px", overflow: "hidden" },
                }}
            >
                <div style={{ ...styles.modalBox, boxShadow: "none", borderRadius: 0, maxWidth: "100%", maxHeight: "none", overflowY: "visible" }}>
                    {/* modal header */}
                    <div style={styles.modalHeader}>
                        <span style={{ fontSize: "20px" }}>🔐</span>
                        <span style={styles.modalTitle}>Authenticate Delivery</span>
                        <button
                            style={styles.modalClose}
                            onClick={() => { setOtpModalOpen(false); setOtp(["", "", "", ""]); setStatus("default"); }}
                        >×</button>
                    </div>

                    <p style={styles.modalSub}>Ask the customer for their 4-digit delivery OTP</p>

                    {/* OTP digit boxes */}
                    <div style={styles.otpBoxes}>
                        {otp.map((digit, index) => (
                            <div
                                key={index}
                                style={{
                                    ...styles.otpBox,
                                    borderColor:
                                        status === "error"
                                            ? "#EF4444"
                                            : digit
                                                ? "#37C790"
                                                : index === activeIndex
                                                    ? "#37C790"
                                                    : "#D1D5DB",
                                    background:
                                        status === "error"
                                            ? "#FEF2F2"
                                            : digit ? "#F0FDF8" : "#FAFAFA",
                                    color:
                                        status === "error"
                                            ? "#EF4444"
                                            : digit ? "#065F46" : "#374151",
                                    boxShadow:
                                        index === activeIndex && status !== "error"
                                            ? "0 0 0 3px rgba(55,199,144,0.18)"
                                            : "none",
                                }}
                            >
                                {digit}
                            </div>
                        ))}
                    </div>

                    {status === "error" && (
                        <p style={styles.errorText}>Incorrect OTP. Please try again.</p>
                    )}

                    {/* Confirm button */}
                    <button
                        onClick={verifyOtp}
                        disabled={otp.includes("") || loading}
                        style={{
                            ...styles.confirmBtn,
                            background: otp.includes("") ? "#E5E7EB" : "#37C790",
                            color: otp.includes("") ? "#9CA3AF" : "#fff",
                            cursor: otp.includes("") || loading ? "not-allowed" : "pointer",
                        }}
                    >
                        {loading ? "Verifying..." : "Confirm Delivery"}
                    </button>

                    {/* Keypad */}
                    <div style={styles.keypad}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                            <button
                                key={num}
                                onClick={() => handleNumberClick(num.toString())}
                                style={styles.keyBtn}
                            >
                                {num}
                            </button>
                        ))}
                        <button style={{ ...styles.keyBtn, opacity: 0, pointerEvents: "none" }} />
                        <button onClick={() => handleNumberClick("0")} style={styles.keyBtn}>0</button>
                        <button onClick={handleDelete} style={styles.keyBtn}>
                            <IoMdBackspace />
                        </button>
                    </div>
                </div>
            </Modal>

            {/* ─── Pickup OTP Modal (antd, centered + scrollable) ─── */}
            <Modal
                open={pickupOtpModalOpen}
                onCancel={() => { setPickupOtpModalOpen(false); setPickupOtp(["", "", "", "", "", ""]); setPickupStatus("default"); }}
                footer={null}
                closable={false}
                maskClosable={true}
                centered
                width={440}
                styles={{
                    body: {
                        padding: 0,
                        maxHeight: "85vh",
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                    },
                    content: { padding: 0, borderRadius: "20px", overflow: "hidden" },
                }}
            >
                <div style={{ ...styles.modalBox, boxShadow: "none", borderRadius: 0, maxWidth: "100%", maxHeight: "none", overflowY: "visible" }}>
                    {/* modal header */}
                    <div style={styles.modalHeader}>
                        <span style={{ fontSize: "20px" }}>🔐</span>
                        <span style={styles.modalTitle}>Authenticate Pickup</span>
                        <button
                            style={styles.modalClose}
                            onClick={() => { setPickupOtpModalOpen(false); setPickupOtp(["", "", "", "", "", ""]); setPickupStatus("default"); }}
                        >×</button>
                    </div>

                    <p style={styles.modalSub}>Ask the seller for their 6-digit pickup OTP</p>

                    {/* OTP digit boxes */}
                    <div style={styles.otpBoxes}>
                        {pickupOtp.map((digit, index) => (
                            <div
                                key={index}
                                style={{
                                    ...styles.otpBox,
                                    borderColor:
                                        pickupStatus === "error"
                                            ? "#EF4444"
                                            : digit
                                                ? "#10B981"
                                                : index === pickupActiveIndex
                                                    ? "#10B981"
                                                    : "#D1D5DB",
                                    background:
                                        pickupStatus === "error"
                                            ? "#FEF2F2"
                                            : digit ? "#F0FDF8" : "#FAFAFA",
                                    color:
                                        pickupStatus === "error"
                                            ? "#EF4444"
                                            : digit ? "#065F46" : "#374151",
                                    boxShadow:
                                        index === pickupActiveIndex && pickupStatus !== "error"
                                            ? "0 0 0 3px rgba(16,185,129,0.18)"
                                            : "none",
                                }}
                            >
                                {digit}
                            </div>
                        ))}
                    </div>

                    {pickupStatus === "error" && (
                        <p style={styles.errorText}>Incorrect OTP. Please try again.</p>
                    )}

                    {pickupStatus === "success" && (
                        <p style={styles.successInlineText}>✓ Pickup verified successfully!</p>
                    )}

                    {/* Confirm button */}
                    <button
                        onClick={verifyPickupOtp}
                        disabled={pickupOtp.includes("") || pickupLoading}
                        style={{
                            ...styles.confirmBtn,
                            background: pickupOtp.includes("") ? "#E5E7EB" : "#10B981",
                            color: pickupOtp.includes("") ? "#9CA3AF" : "#fff",
                            cursor: pickupOtp.includes("") || pickupLoading ? "not-allowed" : "pointer",
                        }}
                    >
                        {pickupLoading ? "Verifying..." : "Confirm Pickup"}
                    </button>

                    {/* Keypad */}
                    <div style={styles.keypad}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                            <button
                                key={num}
                                onClick={() => handlePickupNumberClick(num.toString())}
                                style={styles.keyBtn}
                            >
                                {num}
                            </button>
                        ))}
                        <button style={{ ...styles.keyBtn, opacity: 0, pointerEvents: "none" }} />
                        <button onClick={() => handlePickupNumberClick("0")} style={styles.keyBtn}>0</button>
                        <button onClick={handlePickupDelete} style={styles.keyBtn}>
                            <IoMdBackspace />
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

/* ─── styles ──────────────────────────────────────── */
const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        background: "linear-gradient(135deg,#f0fdf8 0%,#f5f3ff 100%)",
        padding: "24px 16px 48px",
    },
    card: {
        width: "100%",
        maxWidth: "440px",
        background: "#fff",
        borderRadius: "20px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
        overflow: "hidden",
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "16px 20px",
        borderBottom: "1px solid #F3F4F6",
        background: "#FAFFFE",
    },
    headerEmoji: { fontSize: "22px" },
    headerTitle: { flex: 1, fontSize: "15px", color: "#111827" },
    orderBadge: {
        fontSize: "12px",
        background: "#EEF2FF",
        color: "#4F46E5",
        padding: "3px 10px",
        borderRadius: "20px",
        fontWeight: 600,
    },
    productRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "14px 20px",
        background: "#FAFAFA",
        borderBottom: "1px solid #F3F4F6",
    },
    productImg: {
        width: "50px",
        height: "50px",
        borderRadius: "10px",
        objectFit: "cover",
        border: "1px solid #E5E7EB",
        flexShrink: 0,
    },
    productName: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#111827",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    productMeta: { display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" },
    productAmount: { fontSize: "14px", fontWeight: 700, color: "#065F46" },
    productQty: { fontSize: "12px", color: "#6B7280" },
    sectionCard: {
        margin: "12px 16px 0",
        border: "1px solid #F3F4F6",
        borderRadius: "12px",
        overflow: "hidden",
    },
    sectionHeader: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 14px",
        background: "#FAFAFA",
        borderBottom: "1px solid #F3F4F6",
        borderLeft: "3px solid #37C790",
    },
    sectionIcon: {
        width: "26px",
        height: "26px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    sectionTitle: { fontSize: "13px", fontWeight: 700, color: "#374151" },
    sectionBody: { padding: "10px 14px" },
    summaryText: {
        fontSize: "11px",
        color: "#6B7280",
        marginTop: "2px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    chevron: {
        fontSize: "18px",
        lineHeight: 1,
        transition: "transform 0.2s ease",
        marginLeft: "6px",
        flexShrink: 0,
    },
    infoRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "6px",
        marginBottom: "8px",
        fontSize: "13px",
    },
    infoIcon: { color: "#9CA3AF", marginTop: "1px", flexShrink: 0 },
    infoLabel: { color: "#6B7280", minWidth: "80px", flexShrink: 0 },
    infoValue: { color: "#111827", fontWeight: 500, flex: 1, wordBreak: "break-word" },
    noData: { color: "#9CA3AF", fontSize: "13px", margin: 0 },
    otpSection: {
        textAlign: "center",
        padding: "20px 20px 24px",
        marginTop: "12px",
    },
    otpIcon: { fontSize: "32px", marginBottom: "8px" },
    otpTitle: { fontSize: "16px", fontWeight: 700, color: "#111827", margin: "0 0 4px" },
    otpSub: { fontSize: "13px", color: "#6B7280", margin: "0 0 20px" },
    otpBoxes: {
        display: "flex",
        justifyContent: "center",
        gap: "8px",
        marginBottom: "4px",
    },
    otpBox: {
        width: "46px",
        height: "52px",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        fontWeight: 700,
        border: "1.5px solid #D1D5DB",
        transition: "all 0.15s ease",
    },
    statusBtnRow: {
        display: "flex",
        gap: "10px",
        margin: "14px 16px 4px",
    },
    statusBtn: {
        flex: 1,
        height: "46px",
        borderRadius: "12px",
        border: "none",
        color: "#fff",
        fontSize: "13px",
        fontWeight: 700,
        transition: "background 0.2s, opacity 0.2s",
        letterSpacing: "0.01em",
    },
    authOtpBtn: {
        display: "block",
        width: "100%",
        marginTop: "12px",
        height: "42px",
        borderRadius: "10px",
        border: "none",
        background: "linear-gradient(135deg, #F59E0B, #D97706)",
        color: "#fff",
        fontSize: "13px",
        fontWeight: 700,
        cursor: "pointer",
        letterSpacing: "0.02em",
        boxShadow: "0 2px 8px rgba(245,158,11,0.30)",
    },
    authPickupBtn: {
        display: "block",
        width: "100%",
        marginTop: "12px",
        height: "42px",
        borderRadius: "10px",
        border: "none",
        background: "linear-gradient(135deg, #10B981, #059669)",
        color: "#fff",
        fontSize: "13px",
        fontWeight: 700,
        cursor: "pointer",
        letterSpacing: "0.02em",
        boxShadow: "0 2px 8px rgba(16,185,129,0.30)",
    },
    /* modal */
    modalBackdrop: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        zIndex: 1000,
    },
    modalBox: {
        width: "100%",
        maxWidth: "440px",
        maxHeight: "88vh",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        background: "#fff",
        borderRadius: "24px 24px 0 0",
        padding: "20px 20px 32px",
        boxShadow: "0 -4px 32px rgba(0,0,0,0.18)",
    },
    modalHeader: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "6px",
    },
    modalTitle: {
        flex: 1,
        fontSize: "16px",
        fontWeight: 700,
        color: "#111827",
    },
    modalClose: {
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        border: "none",
        background: "#F3F4F6",
        color: "#374151",
        fontSize: "20px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
    },
    modalSub: {
        fontSize: "12px",
        color: "#6B7280",
        margin: "0 0 16px",
    },
    errorText: { color: "#EF4444", fontSize: "13px", textAlign: 'center', fontWeight: 500, margin: "8px 0 0" },
    successInlineText: { color: "#059669", fontSize: "13px", fontWeight: 600, margin: "8px 0 0" },
    confirmBtn: {
        width: "100%",
        height: "48px",
        borderRadius: "12px",
        border: "none",
        fontSize: "15px",
        fontWeight: 700,
        marginTop: "18px",
        transition: "background 0.2s",
    },
    keypad: {
        display: "grid",
        gridTemplateColumns: "repeat(3,1fr)",
        gap: "8px",
        marginTop: "16px",
    },
    keyBtn: {
        height: "52px",
        borderRadius: "12px",
        border: "1px solid #E5E7EB",
        background: "#fff",
        fontSize: "20px",
        fontWeight: 600,
        cursor: "pointer",
        color: "#111827",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    skeletonHeader: {
        height: "56px",
        background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
    },
    skeleton: {
        height: "16px",
        borderRadius: "8px",
        margin: "0 20px",
        background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
    },
    successRing: {
        width: "90px",
        height: "90px",
        border: "3px solid #37C790",
        borderRadius: "50%",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    successCheck: {
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        background: "#37C790",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "26px",
        fontWeight: 700,
    },
    successTitle: { marginTop: "20px", marginBottom: "8px", color: "#111827", fontSize: "20px" },
    successSub: { color: "#6B7280", fontSize: "14px", lineHeight: "22px", marginBottom: "20px" },
};

export default VerifyOTP;